import React, { useEffect } from 'react';

import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import useUserHook from 'hooks/useUserHook';

import { useBattleCardsStore } from 'store/battlecards.store';
import { useMobileStore } from 'store/mobile.store';

import GuardedRoute from 'components/common/GuardedRoute/guardedRoute';
import { DisplayStyle } from 'components/common/ToggleView/ToggleView';

import { HeaderMobile } from 'components/Mobile/components/header/header.mobile';
import { NavbarMobile } from 'components/Mobile/components/navbar/navbar.mobile';
import { mobileAppConfig } from 'components/Mobile/mobileConfig';
import { ActivitiesMobile } from 'components/Mobile/pages/activities/activities.mobile';
import NoDataFoundMobile from 'components/Mobile/pages/errors/noDataFound.mobile';
import PageNotFoundMobile from 'components/Mobile/pages/errors/pageNotFound.mobile';
import { HomeMobile } from 'components/Mobile/pages/home/home.mobile';
import { MobileNotifications } from 'components/Mobile/pages/notifications/mobileNotifications';

import classes from './mobile.module.scss';

export const MobileRoutes = () => {
    const { path } = useRouteMatch();
    const { ability } = useUserHook();
    const setDisplayStyle = useBattleCardsStore((state) => state.setDisplayStyle);
    const { update } = useMobileStore();

    useEffect(() => {
        update({ isMobile: true });
        setDisplayStyle(DisplayStyle.COLUMNS);

        return () => {
            update({ isMobile: false });
        };
    }, []);

    return (
        <div className={classes.MobileScreenContainer}>
            <div data-testid={'mobile-header'} className={classes.mobileHeader}>
                <HeaderMobile />
            </div>
            <div className={`${classes.mobileMainContent}`}>
                <Switch>
                    <GuardedRoute
                        path={`${path}/${mobileAppConfig.notifications.link}`}
                        component={MobileNotifications}
                        auth={true}
                        redirect={`${path}/no-access`}
                    />
                    <GuardedRoute
                        path={`${path}/${mobileAppConfig.activities.link}/:id`}
                        component={ActivitiesMobile}
                        auth={ability.can('view', 'BattleCards')}
                        redirect={`${path}/no-access`}
                    />
                    <GuardedRoute
                        path={`${path}/${mobileAppConfig.home.link}/:id`}
                        component={HomeMobile}
                        auth={true}
                        redirect={`${path}/no-access`}
                    />
                    <Redirect exact from={'/mobile'} to={`${path}/${mobileAppConfig.home.link}/`} />
                    {/*check if the below redirect can be removed*/}
                    <Redirect exact from={'/mobile/home'} to={`${path}/${mobileAppConfig.home.link}/`} />
                    <Route path={`/mobile/${mobileAppConfig.noDataFound.link}`} component={NoDataFoundMobile} />
                    <Route path={'*'} component={PageNotFoundMobile} />
                </Switch>
            </div>
            <div className={classes.mobileFooter}>
                <NavbarMobile />
            </div>
        </div>
    );
};
